// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { specificationsStyles } from "@pace/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import { css } from "styled-components";

specificationsStyles.specificationsAccordion = {
    headingLevel: 1,
    css: css`
        @media print {
            page-break-before: always;
        }
    `,
};

specificationsStyles.specificationsAccordionSection = {
    headerProps: {
        css: css`
            @media print {
                button {
                    display: block !important;
                }
            }
        `,
    },
    toggleIconProps: {
        css: css`
            ${IconWrapper}, svg {
                width: 15px;
                height: 9px;
                @media print {
                    display: none;
                }
            }
        `,
    },
    panelProps: {
        css: css`
            @media print {
                display: flex;
                width: 100%;
            }
        `,
    },
};

specificationsStyles.accordionWrapper = {
    css: css`
        @media print {
            page-break-inside: avoid;
        }
    `,
};
